import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  devTools: import.meta.env.VITE_ENABLE_REDUX_DEV_TOOLS === 'true',
})

export type RootState = ReturnType<typeof store.getState>

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector

export type AppDispatch = typeof store.dispatch

export const useDispatch: () => AppDispatch = () => useReduxDispatch<AppDispatch>()

type ActionType<T extends (action: any) => any> = T extends (action: infer A) => any ? A : never

export function asDispatchFn<TArgs extends any[]>(
  dispatch: AppDispatch,
  fn: (...args: TArgs) => ActionType<AppDispatch>
): (...args: TArgs) => void {
  return (...args: TArgs) => dispatch(fn(...args))
}

export default store
